
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("JSoWM", function(module, exports) {
$parcel$export(module.exports, "FooterLabels", () => (parcelRequire("1xzIe")).FooterLabels);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $1xzIe = parcelRequire("1xzIe");


});

parcelRegister("hysf6", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");


var $aWwYt = parcelRequire("aWwYt");


var $jvYFk = parcelRequire("jvYFk");


var $jmjWc = parcelRequire("jmjWc");


const $4119a6166d969e95$var$DetailsPanelHeaderIcon = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "TmpiW",
    name: "DetailsPanelHeaderIcon",
    loader: async ()=>(await (parcelRequire("h5lQ3"))).DetailsPanelHeaderIcon
});

const $4119a6166d969e95$var$DetailsPanelBody = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "WdQRW",
    name: "DetailsPanelBody",
    loader: async ()=>(await (parcelRequire("dTy7q"))).DetailsPanelBody
});
const $4119a6166d969e95$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    detailsPanelHeaderLabel: {
        id: "details-panel.panel.header.label",
        defaultMessage: "Details"
    }
});
const $4119a6166d969e95$export$fd546c83bdd1393d = ()=>{
    const { showObjectSidebar: showObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const panel = (0, $aWwYt.usePanel)();
    const showDetailsPanel = ({ highlightLabels: highlightLabels } = {})=>{
        showObjectSidebar({
            id: (0, $jvYFk.PanelName).DetailsPanel,
            headerComponentElements: {
                HeaderIcon: $4119a6166d969e95$var$DetailsPanelHeaderIcon,
                headerLabel: $4119a6166d969e95$export$a7357cdd1f0b0168.detailsPanelHeaderLabel
            },
            BodyComponent: $4119a6166d969e95$var$DetailsPanelBody,
            props: {
                highlightLabels: highlightLabels
            }
        }, 'push');
    };
    return {
        isDetailsPanelShown: isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).DetailsPanel,
        showDetailsPanel: showDetailsPanel
    };
};
module.exports["useShowDetailsPanel"] = $4119a6166d969e95$export$fd546c83bdd1393d;

});

parcelRegister("h5lQ3", function(module, exports) {

let $c703d7ffe269eb96$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c703d7ffe269eb96$var$load("83dhc"),
    $c703d7ffe269eb96$var$load("cP7II"),
    $c703d7ffe269eb96$var$load("9aQIt"),
    $c703d7ffe269eb96$var$load("XZauT"),
    $c703d7ffe269eb96$var$load("4S1SF"),
    $c703d7ffe269eb96$var$load("jiFtb"),
    $c703d7ffe269eb96$var$load("lm9Lt"),
    $c703d7ffe269eb96$var$load("9wPDc"),
    $c703d7ffe269eb96$var$load("1MWOL"),
    $c703d7ffe269eb96$var$load("6fQco"),
    $c703d7ffe269eb96$var$load("aOY32"),
    $c703d7ffe269eb96$var$load("a08Vk"),
    $c703d7ffe269eb96$var$load("jtwfh"),
    $c703d7ffe269eb96$var$load("gdprR"),
    $c703d7ffe269eb96$var$load("dtpmo"),
    $c703d7ffe269eb96$var$load("9GDly"),
    $c703d7ffe269eb96$var$load("gctwz"),
    $c703d7ffe269eb96$var$load("l4YAS"),
    $c703d7ffe269eb96$var$load("9zOlm"),
    $c703d7ffe269eb96$var$load("hhss7"),
    $c703d7ffe269eb96$var$load("Wowvf"),
    $c703d7ffe269eb96$var$load("dek7I"),
    $c703d7ffe269eb96$var$load("dYtBN"),
    $c703d7ffe269eb96$var$load("kNV5Y"),
    $c703d7ffe269eb96$var$load("kjZZD"),
    $c703d7ffe269eb96$var$load("99Ppz"),
    $c703d7ffe269eb96$var$load("5v2fx"),
    $c703d7ffe269eb96$var$load("iTJMK"),
    $c703d7ffe269eb96$var$load("2A8WX"),
    $c703d7ffe269eb96$var$load("7tgvK"),
    $c703d7ffe269eb96$var$load("6wr18"),
    $c703d7ffe269eb96$var$load("ffEVr"),
    $c703d7ffe269eb96$var$load("8zlfy")
]).then(()=>parcelRequire('7N9MO'));

});

parcelRegister("dTy7q", function(module, exports) {

let $a1dae0ab65994dee$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a1dae0ab65994dee$var$load("83dhc"),
    $a1dae0ab65994dee$var$load("cP7II"),
    $a1dae0ab65994dee$var$load("9aQIt"),
    $a1dae0ab65994dee$var$load("XZauT"),
    $a1dae0ab65994dee$var$load("4S1SF"),
    $a1dae0ab65994dee$var$load("jiFtb"),
    $a1dae0ab65994dee$var$load("lm9Lt"),
    $a1dae0ab65994dee$var$load("9wPDc"),
    $a1dae0ab65994dee$var$load("1MWOL"),
    $a1dae0ab65994dee$var$load("6fQco"),
    $a1dae0ab65994dee$var$load("aOY32"),
    $a1dae0ab65994dee$var$load("a08Vk"),
    $a1dae0ab65994dee$var$load("jtwfh"),
    $a1dae0ab65994dee$var$load("gdprR"),
    $a1dae0ab65994dee$var$load("dtpmo"),
    $a1dae0ab65994dee$var$load("9GDly"),
    $a1dae0ab65994dee$var$load("gctwz"),
    $a1dae0ab65994dee$var$load("l4YAS"),
    $a1dae0ab65994dee$var$load("9zOlm"),
    $a1dae0ab65994dee$var$load("hhss7"),
    $a1dae0ab65994dee$var$load("Wowvf"),
    $a1dae0ab65994dee$var$load("dek7I"),
    $a1dae0ab65994dee$var$load("dYtBN"),
    $a1dae0ab65994dee$var$load("kNV5Y"),
    $a1dae0ab65994dee$var$load("kjZZD"),
    $a1dae0ab65994dee$var$load("99Ppz"),
    $a1dae0ab65994dee$var$load("5v2fx"),
    $a1dae0ab65994dee$var$load("iTJMK"),
    $a1dae0ab65994dee$var$load("2A8WX"),
    $a1dae0ab65994dee$var$load("7tgvK"),
    $a1dae0ab65994dee$var$load("6wr18"),
    $a1dae0ab65994dee$var$load("ffEVr"),
    $a1dae0ab65994dee$var$load("8zlfy")
]).then(()=>parcelRequire('9igqG'));

});

parcelRegister("4vaoM", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $a85e440150ad6165$export$761f49b4caa7a581 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "JXn3W",
    name: "EditLabelDialogLoader",
    loader: async ()=>(await (parcelRequire("bsI19"))).EditLabelDialogComponent
});
module.exports["EditLabelDialogLoader"] = $a85e440150ad6165$export$761f49b4caa7a581;

});

parcelRegister("bsI19", function(module, exports) {

let $8584743abc7f519f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8584743abc7f519f$var$load("dUwYW"),
    $8584743abc7f519f$var$load("jigcs"),
    $8584743abc7f519f$var$load("1fnbu")
]).then(()=>parcelRequire('m0wkE'));

});

parcelRegister("gfIPU", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

function $5675860ef242c9e4$export$eed1d73ebdd8c7ab(t0) {
    const $ = (0, $frIzR.c)(6);
    const { name: name, error: error, attributes: attributes } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== error || $[2] !== experienceTracker || $[3] !== name) {
        t1 = ()=>experienceTracker.fail({
                name: name,
                error: error,
                attributes: attributes
            });
        t2 = [
            experienceTracker,
            name,
            error,
            attributes
        ];
        $[0] = attributes;
        $[1] = error;
        $[2] = experienceTracker;
        $[3] = name;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $42omo.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceFailure"] = $5675860ef242c9e4$export$eed1d73ebdd8c7ab;

});

parcelRegister("1xzIe", function(module, exports) {
/**
 * @generated SignedSource<<c48b6be655d4374fb38cd89b3237bb6e>>
 * @relayHash ce6f8c535e465c9ec85be5fec79cf74e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 358f0c56d1ed684e042086e4f59a2081d526c83e983bedfad481943e1c1260f2
const $e4c12f84c9729495$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "orderBy",
                            "value": {
                                "direction": "ASCENDING",
                                "sortField": "LABELLING_CREATIONDATE"
                            }
                        }
                    ],
                    "concreteType": "PaginatedLabelList",
                    "kind": "LinkedField",
                    "name": "labels",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Label",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "label"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "prefix"
                                }
                            ]
                        }
                    ],
                    "storageKey": "labels(orderBy:{\"direction\":\"ASCENDING\",\"sortField\":\"LABELLING_CREATIONDATE\"})"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "FooterLabelsQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "FooterLabelsQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "ce6f8c535e465c9ec85be5fec79cf74e",
            "id": "358f0c56d1ed684e042086e4f59a2081d526c83e983bedfad481943e1c1260f2",
            "metadata": {},
            "name": "FooterLabelsQuery",
            "operationKind": "query",
            "text": "query FooterLabelsQuery($contentId:ID!){singleContent(id:$contentId){id,type,operations{operation,targetType},labels(orderBy:{sortField:LABELLING_CREATIONDATE,direction:ASCENDING}){nodes{id,label,name,prefix}}}}"
        }
    };
}();
$e4c12f84c9729495$var$node.hash = "bb68fd74b2f9113aeb9d5e262c5714cc";
var $e4c12f84c9729495$export$2e2bcd8739ae039 = $e4c12f84c9729495$var$node;



var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $5nBzc = parcelRequire("5nBzc");


var $dcJ7R = parcelRequire("dcJ7R");

var $2W0qg = parcelRequire("2W0qg");

var $ecnYn = parcelRequire("ecnYn");


var $av0Vd = parcelRequire("av0Vd");


var $3gadb = parcelRequire("3gadb");


var $ep3mz = parcelRequire("ep3mz");


var $b3j2Y = parcelRequire("b3j2Y");


var $8aF6s = parcelRequire("8aF6s");


var $hysf6 = parcelRequire("hysf6");


var $4vaoM = parcelRequire("4vaoM");


var $irVI7 = parcelRequire("irVI7");


var $gfIPU = parcelRequire("gfIPU");

var $1eaCJ = parcelRequire("1eaCJ");


var $6mKj3 = parcelRequire("6mKj3");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $jMyy4 = parcelRequire("jMyy4");

const $0edb016a56df6289$export$ef7716fb21e26e68 = ()=>{
    const [contentId = ''] = (0, $ep3mz.usePageContentId)();
    const [spaceKey = ''] = (0, $ep3mz.usePageSpaceKey)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { showDetailsPanel: showDetailsPanel } = (0, $hysf6.useShowDetailsPanel)();
    const labelsShortcutStrings = (0, $4tOXV.useShortcutStrings)({
        shortcut: (0, $gnkil.UNIVERSAL_LABELS_SHORTCUT)
    });
    const { loading: loading, data: data, error: error } = (0, $jMyy4.useQueryInterop)((0, $e4c12f84c9729495$export$2e2bcd8739ae039), {
        variables: {
            contentId: contentId
        },
        __callerPackage__: "@confluence/labels-footer"
    });
    if (loading) return null;
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gfIPU.ExperienceFailure), {
        name: (0, $irVI7.VIEW_PAGE_LABELS_IN_FOOTER_EXPERIENCE),
        error: error
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }));
    const content = data?.singleContent;
    const hasEditPermissions = Boolean(content?.operations?.find((item)=>item?.operation === 'update' && item?.targetType === content?.type));
    const labels = content?.labels?.nodes?.filter((node)=>node?.name !== 'favourite' || node?.prefix !== 'my') || [];
    if (labels.length === 0) {
        if (!hasEditPermissions) // don't show anything if user doesn't have edit permissions
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.VIEW_PAGE_LABELS_IN_FOOTER_EXPERIENCE),
            attributes: {
                hasEditPermissions: hasEditPermissions,
                labelsCount: labels.length
            }
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: (0, $6mKj3.expValEquals)('confluence_comments_cohiti_footer_tooltips', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $0edb016a56df6289$var$i18n.addLabelTooltip) : undefined,
            shortcut: labelsShortcutStrings,
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            xcss: $0edb016a56df6289$var$addLabelsButton,
            onClick: ()=>showModal((0, $4vaoM.EditLabelDialogLoader), {
                    contentId: contentId,
                    spaceKey: spaceKey,
                    source: 'labelsFooter'
                })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($av0Vd))), {
            label: ""
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $0edb016a56df6289$var$i18n.addLabels)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.VIEW_PAGE_LABELS_IN_FOOTER_EXPERIENCE),
            attributes: {
                labelsCount: labels.length,
                hasEditPermissions: hasEditPermissions
            }
        }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: (0, $6mKj3.expValEquals)('confluence_comments_cohiti_footer_tooltips', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $0edb016a56df6289$var$i18n.manageLabelsTooltip) : undefined,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
        xcss: $0edb016a56df6289$var$labelsContainer,
        onClick: ()=>{
            showDetailsPanel({
                highlightLabels: true
            });
        }
    }, labels.slice(0, 2).map((label)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
            key: label?.id
        }, label?.name)), labels.length > 2 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        xcss: $0edb016a56df6289$var$additionalLabels
    }, "+", labels.length - 2)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.VIEW_PAGE_LABELS_IN_FOOTER_EXPERIENCE),
        attributes: {
            labelsCount: labels.length
        }
    }));
};
const $0edb016a56df6289$var$labelsContainer = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.100',
    paddingInline: 'space.100',
    paddingBlock: 'space.050',
    height: '32px',
    backgroundColor: 'color.background.neutral.subtle',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
const $0edb016a56df6289$var$additionalLabels = (0, $ecnYn.xcss)({
    font: 'font.body.small',
    fontWeight: 'font.weight.bold',
    paddingInline: 'space.050'
});
const $0edb016a56df6289$var$addLabelsButton = (0, $ecnYn.xcss)({
    display: 'flex',
    gap: 'space.100',
    alignItems: 'center',
    paddingInline: 'space.150',
    borderRadius: 'radius.small',
    color: 'color.text.subtle',
    font: 'font.body',
    height: '32px',
    backgroundColor: 'color.background.neutral.subtle',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
const $0edb016a56df6289$var$i18n = (0, $aXWIB.defineMessages)({
    addLabels: {
        id: "labels-footer.addLabels",
        defaultMessage: "Add labels"
    },
    addLabelTooltip: {
        id: "labels-footer.addLabel-tooltip",
        defaultMessage: "Add label"
    },
    manageLabelsTooltip: {
        id: "labels-footer.manageLabels-tooltip",
        defaultMessage: "Manage labels"
    }
});
module.exports["FooterLabels"] = $0edb016a56df6289$export$ef7716fb21e26e68;

});


//# sourceMappingURL=labels-footer.9bfebd72.js.map
